export type AccountFlowStep =
  | 'phone'
  | 'password'
  | 'register'
  | 'forgot-password'
  | 'forgot-password-sent'
  | 'reset-password'

export type AccountFlowContent = {
  title: string
  description: string
  buttonLabel: string
  loadingLabel: string
  notice: string | null
}

export function getAccountFlowContent(step: AccountFlowStep): AccountFlowContent {
  switch (step) {
    case 'password':
      return {
        title: 'Conta encontrada',
        description: 'Digite sua senha da Sortee para continuar.',
        buttonLabel: 'Entrar e continuar',
        loadingLabel: 'Entrando...',
        notice: null,
      }
    case 'register':
      return {
        title: 'Complete seu cadastro',
        description:
          'Complete seus dados para criar sua conta na Sortee e participar de qualquer campanha.',
        buttonLabel: 'Cadastrar e continuar',
        loadingLabel: 'Criando conta...',
        notice:
          'Informe também um e-mail válido para receber comunicações e recuperar sua senha.',
      }
    case 'forgot-password':
      return {
        title: 'Recuperar senha',
        description:
          'Enviaremos o link por e-mail e WhatsApp, conforme os contatos cadastrados na sua conta Sortee.',
        buttonLabel: 'Enviar link de recuperação',
        loadingLabel: 'Enviando...',
        notice: null,
      }
    case 'forgot-password-sent':
      return {
        title: 'Verifique seu e-mail e WhatsApp',
        description:
          'Se houver uma conta com este telefone, enviaremos o link ao e-mail e WhatsApp disponíveis no cadastro.',
        buttonLabel: 'Voltar ao login',
        loadingLabel: 'Voltando...',
        notice: 'O link expira após algum tempo. Confira também a caixa de spam.',
      }
    case 'reset-password':
      return {
        title: 'Nova senha',
        description: 'Defina uma nova senha para sua conta na Sortee.',
        buttonLabel: 'Salvar nova senha',
        loadingLabel: 'Salvando...',
        notice: null,
      }
    case 'phone':
    default:
      return {
        title: 'Entrar',
        description:
          'Use seu WhatsApp para acessar sua conta na Sortee. O mesmo cadastro vale para todas as campanhas.',
        buttonLabel: 'Continuar',
        loadingLabel: 'Verificando...',
        notice: null,
      }
  }
}

export function getAccountPrimaryButtonIcon(
  step: AccountFlowStep,
  isSubmitting: boolean
): string {
  if (isSubmitting) {
    return 'mdi:loading'
  }

  switch (step) {
    case 'phone':
      return 'mdi:arrow-right'
    case 'password':
      return 'mdi:login'
    case 'register':
      return 'mdi:account-plus'
    case 'forgot-password':
      return 'mdi:email-send'
    case 'forgot-password-sent':
      return 'mdi:arrow-left'
    case 'reset-password':
      return 'mdi:lock-reset'
    default:
      return 'mdi:arrow-right'
  }
}
